import React from 'react';
import './Chunk.scss';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import axios from 'axios';
import yaml from 'js-yaml';
import Media from '../Media/Media';
import Asset from '../Asset/Asset';
import Columns from '../Columns/Columns';
import Chunk from '../Chunks/Chunk';
import Loader from '../common/Loading/Loading';

const components = {
  Media,
  Asset,
  Columns,
  Chunk
};

const getAssetTextContent = (manifest, dataUrl) => {
  let xhr = 0;
  let needsContentCount = 0;
  let config = {
    // dumb, but putting JSON in md files still comes through as an object.
    // this makes it come through as text for Command Window
    transformResponse: undefined
  };
  let promise = new Promise((resolve, reject) => {
    manifest.assets.forEach(asset => {
      if (asset.type === 'text' && !asset.content && asset.content !== '') {
        xhr++;
        needsContentCount++;
        axios.get(`${dataUrl}assets/${asset.file}`, config).then(assetMD => {
          asset.content = assetMD.data;
          xhr--;
          if (xhr === 0) {
            resolve(manifest);
          }
        });
      }
    });
    if (needsContentCount === 0) {
      resolve(manifest);
    }
  });
  return promise;
};

const RenderComponent = ({ componentDef, componentKey }) => {
  const createComponent = (def, key) => {
    // addding key attr for the components being rendered
    def.props.key = key;
    let compType = components[def.componentType];
    let props = def.props;
    let children = def.children || [];

    // Rendering Media, Asset, Columns, Chunk Components without JSX/MDX
    return React.createElement(
      compType,
      props,
      children.map((childCompDef, index) =>
        createComponent(childCompDef, index)
      )
    );
  };

  return createComponent(componentDef, componentKey);
};

const Chunks = () => {
  const reduxDispatch = useDispatch();
  const {
    blockJsonData,
    dataUrl,
    dataLoadComplete,
    dataUrlBase,
    courseId,
    commonAssets,
    language
  } = useSelector(
    state => ({
      blockJsonData: state.BlockState.blockJsonData,
      dataUrl: state.BlockState.dataUrl,
      dataLoadComplete: state.BlockState.dataLoadComplete,
      dataUrlBase: state.CourseState.dataUrlBase,
      courseId: state.CourseState.courseId,
      commonAssets: state.CourseState.commonAssets,
      language: state.CourseState.language
    }),
    shallowEqual
  );

  const assetLoadedCallback = (block, assets, common) => {
    getAssetTextContent(assets, dataUrl).then(parsedAssets => {
      reduxDispatch({
        type: 'INIT_DATA',
        display: 'stacked',
        blockJsonData: block.data,
        assetManifest: parsedAssets,
        dataLoadComplete: true
      });

      if (common) {
        reduxDispatch({
          type: 'COMMON_ASSETS',
          commonAssets: common
        });
      }
    });
  };

  if (!dataLoadComplete) {
    axios.get(`${dataUrl}block.json`).then(block => {
      axios.get(`${dataUrl}assets/assets_${language.code}.yml`).then(assets => {
        if (!commonAssets) {
          axios
            .get(
              `${dataUrlBase}/${courseId}/_common/assets_${language.code}.yml`
            )
            .then(assetsCommon => {
              let cmnAssts = yaml.safeLoad(assetsCommon.data);
              let blockAssets = yaml.safeLoad(assets.data);
              let combinedAssets = {
                assets: blockAssets.assets.concat(cmnAssts.assets)
              };
              assetLoadedCallback(block, combinedAssets, cmnAssts);
            })
            .catch(err => {
              // console.log('err :', err.response.status);
              // Load the assets if we don't have a common assets.yml
              assetLoadedCallback(block, yaml.safeLoad(assets.data));
            });
        } else {
          let blockAssets = yaml.safeLoad(assets.data);

          let combinedAssets = {
            assets: blockAssets.assets.concat(commonAssets.assets)
          };
          assetLoadedCallback(block, combinedAssets);
        }
      });
    });
  }

  if (!blockJsonData) return <Loader context="Markdown" />;
  return (
    <div className={`content-chunks`} id="chunks-container">
      {blockJsonData.components.map((compObj, index) => (
        <RenderComponent
          key={index}
          componentKey={index}
          componentDef={compObj}
        />
      ))}
    </div>
  );
};
export default Chunks;
